export type WorkspaceDashboardSectionId =
  | 'create'
  | 'visualPrompts'
  | 'recentActivity'
  | 'directory'
  | 'workflows';

export type WorkspaceDashboardSectionState = Record<
  WorkspaceDashboardSectionId,
  boolean
>;

const STORAGE_KEY = 'litium-workspace-dashboard-sections';

export const DEFAULT_WORKSPACE_DASHBOARD_SECTION_STATE: WorkspaceDashboardSectionState =
  {
    create: true,
    visualPrompts: true,
    recentActivity: true,
    directory: true,
    workflows: true,
  };

export const readWorkspaceDashboardSectionState =
  (): WorkspaceDashboardSectionState => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return { ...DEFAULT_WORKSPACE_DASHBOARD_SECTION_STATE };
      }

      const parsed = JSON.parse(raw) as Record<string, unknown>;
      const next = { ...DEFAULT_WORKSPACE_DASHBOARD_SECTION_STATE };

      for (const key of Object.keys(next) as WorkspaceDashboardSectionId[]) {
        if (typeof parsed[key] === 'boolean') {
          next[key] = parsed[key];
        }
      }

      return next;
    } catch {
      return { ...DEFAULT_WORKSPACE_DASHBOARD_SECTION_STATE };
    }
  };

export const writeWorkspaceDashboardSectionState = (
  state: WorkspaceDashboardSectionState,
): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Ignore quota / privacy errors
  }
};
